/**
 * Make an object from an array of keys.
 */
export function makeRecord<K extends string | number | symbol, T>(
	keys: readonly K[],
	valueFn: (k: K) => T
): Record<K, T> {
	const r = {} as Record<K, T>;

	for (const k of keys) {
		r[k] = valueFn(k);
	}

	return r;
}
